import { filter, includes, orderBy } from "lodash";
import apiAction from "../ajax/service";
import {setLeadsInfo} from "../features/rentSlice";

const loadLeads = async(
    dispatch,
    page=1,
    limit=25,
    pageData={},
    leadsFilters={}
)=>{
    if (pageData instanceof Set){
        if (pageData.has(page)) return;
    } else {
        if (page in pageData) return;
    }

    var data = await apiAction("leads",{page, limit , filters : {...leadsFilters,orderBy:{createdAt:"desc"}, include:{rentals:{select:{id:true,name:true}}}}},"custom");
    dispatch(setLeadsInfo({data: data ,page:page, total:data.totalRecords, currentPage:data.currentPage}))
}

const getRentalAvailability = async (startDate, endDate , rentalIds ) =>{
    return await apiAction("availability", {startDate ,endDate , rentalIds},'getRentalsAvailability')
}
const convertLeadToEvent = async(data) =>{
    const tenantInfo = {email:data.email,address:data.address,name:data.email,phone:data.phone}
    const eventInfo = {name:`Event ${Date.now()}`, startDate:data.startDate, endDate:data.endDate , description:`Description for Event ${Date.now()}`}
    const convertedEventData = await apiAction('events',{event:eventInfo,tenant:tenantInfo},'convertToEvent')
    return convertedEventData
}
export {loadLeads,getRentalAvailability,convertLeadToEvent};
